import React, { ReactElement, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { Alert, LinkButton } from '../../../../../components/CiscoUi';
import { HelpButtonContainer } from '../../../../../components/HelpButton/container.tsx';
import { PageHeading } from '../../../../../components/PageHeading';
import { HARDWARE_ALL_HELP_LINKS } from '../../../../../constants/user-guide';
import UserRoleGuardContainer from '../../../../../auth/components/UserRoleGuard/container';
import { INTERNAL_USER_ROLES } from '../../../../constants.ts';
import { AllHardwareProps } from './container';
import { DeleteModal } from './DeleteModal';
import { Table } from './Table';
import styles from './All.module.css';

export function All({
  hardware,
  hardwareToDelete,
  isError,
  isLoading,
  setHardwareToDelete,
}: AllHardwareProps): ReactElement {
  const { t } = useTranslation();
  const match = useRouteMatch();

  const onDeleteClick = useCallback(
    (hardware: Hardware) => {
      setHardwareToDelete(hardware);
    },
    [setHardwareToDelete],
  );

  return (
    <>
      <PageHeading
        pageTitle={t('hardware.physicalHardware.name')}
        useCustomStyling={true}
        ctaBtn={
          <UserRoleGuardContainer requiredRoles={INTERNAL_USER_ROLES}>
            <LinkButton
              size="wide"
              to={`${match.url}/add`}
              testId="hardware-all-new-button"
              className={classNames(styles.button, 'btn--large')}
            >
              {t('buttons.new')}
            </LinkButton>
          </UserRoleGuardContainer>
        }
      />
      {!isLoading && !hardware?.length ? (
        <Alert colour="info">{t('hardware.empty.alertText')}</Alert>
      ) : (
        <Table
          hardware={hardware}
          loading={isLoading}
          isError={isError}
          isLoading={isLoading}
          onDeleteClick={onDeleteClick}
        />
      )}
      {hardwareToDelete && (
        <DeleteModal
          hardware={hardwareToDelete}
          onClose={() => setHardwareToDelete(undefined)}
        />
      )}
      <HelpButtonContainer links={HARDWARE_ALL_HELP_LINKS} />
    </>
  );
}
